export default __webpack_public_path__ + "static/blogImage-b72cb849f740fc5a7e5b2d5937cb33bc.png";